import React, { useEffect, useState } from "react";
import BasePage from "./Components/Pages/Base/BasePage";
import UserContext from "./Components/Contexts/UserContext";
import AdContext from "./Components/Contexts/AdContext";
import VideoContext from "./Components/Contexts/VideoContext";
import "./Styles/Funker530.scss";
import ErrorBoundary from "./Components/Generic/ErrorBoundary";
import SurveyModal, {
  surveyStorageKey,
} from "./Components/Generic/SurveyModal";
import { SURVEY_ACTIVE_API_URL } from "./Components/Constants/APIConstants";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";

// Normalise a path for comparison: lowercase, leading slash, no trailing slash.
// An empty/undefined target_path means the homepage ("/").
function normalizePath(p) {
  let s = (p || "/").trim().toLowerCase();
  if (!s.startsWith("/")) s = `/${s}`;
  if (s.length > 1 && s.endsWith("/")) s = s.slice(0, -1);
  return s;
}

function Funker530() {
  ReactGA.initialize("G-0RHX2WKB1Q");
  ReactGA.gtag("config", "G-0RHX2WKB1Q");

  // Show the active admin-authored survey once per browser, on first load, and
  // only on the path it's targeted at (default: homepage).
  const [survey, setSurvey] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(SURVEY_ACTIVE_API_URL);
        if (!res.ok) return;
        const active = (await res.json())?.survey;
        if (cancelled || !active || !(active.answers?.length >= 2)) return;

        // Already answered this survey? Skip.
        if (localStorage.getItem(surveyStorageKey(active.survey_key))) return;

        // Only show on the survey's target path (null = homepage).
        if (
          normalizePath(active.target_path) !==
          normalizePath(window.location.pathname)
        ) {
          return;
        }

        setSurvey(active);
      } catch {
        // Network/localStorage unavailable — skip the survey.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ErrorBoundary
      customError="There was an error loading Funker530.com. The site is currently undergoing maintenance, please try again in a few moments."
      className="mainError"
    >
      <HelmetProvider>
        <UserContext>
          <AdContext>
            <VideoContext>
              {survey && (
                <SurveyModal
                  survey={survey}
                  onClose={() => setSurvey(null)}
                />
              )}
              <BasePage />
            </VideoContext>
          </AdContext>
        </UserContext>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default Funker530;
